import {
  Badge,
  Collapse,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Fragment, useEffect, useMemo, useState } from "react";
import { Link, Navigate, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DrawerList from "./DrawerList";
import { useLayoutEffect } from "react";
import { useDrawer } from "src/_contexts/DrawerContext";
import { useSelector } from "react-redux";

export default function DrawerListItem({ tab, tab_sx }) {
  const { openSidebarDialog } = useSelector((state) => state.entities.tutorial);
  const { t } = useTranslation();
  const { profile } = useSelector((state) => state.entities.profile);

  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const drawerContext = useDrawer();

  useLayoutEffect(() => {
    if (tab?.noCollapse) {
      setOpen(true);
    }
  }, [tab]);

  // Determine selection by matching pathname and only the 'status' query param; ignore other params
  const selected = (() => {
    if (!tab?.href) return false;
    const [hrefPath, hrefSearch = ""] = String(tab.href).split("?");
    const currentPath = location?.pathname;

    if (currentPath !== hrefPath) return false;

    const getStatus = (searchStr) => {
      try {
        const qs = searchStr
          ? searchStr.startsWith("?")
            ? searchStr
            : `?${searchStr}`
          : "";
        return new URLSearchParams(qs).get("status");
      } catch {
        return null;
      }
    };

    const currentStatus = getStatus(location?.search || "");
    const hrefStatus = getStatus(hrefSearch);

    // If tab defines a specific status, require an exact match; otherwise select only when there's no status in URL
    return hrefStatus !== null
      ? currentStatus === hrefStatus
      : currentStatus === null;
  })();

  const isMapitShipOnly =
    profile?.merchant?.deliveryMethod?.length === 1 &&
    profile?.merchant?.deliveryMethod?.includes("MAPIT_SHIP");

  useEffect(() => {
    if (isMapitShipOnly && tab?.title === "Mapit Ship") {
      setOpen(true);
    } else {
      setOpen(false);
    }

  }, [isMapitShipOnly]);

  return (
    <>
      {tab?.children?.length ? (
        <Fragment>
          <ListItemButton
            id={tab?.id}
            sx={{ color: "text.title", ...tab_sx }}
            // tab_sx={{ pl: 6 }}
            selected={selected}
            onClick={(event) => {
              event.stopPropagation();
              if (!!tab.href) {
                navigate(tab.href);
                drawerContext?.close && drawerContext?.close();
              }
              setOpen((prevState) => !prevState);
            }}
          >
            {!!tab?.icon && (
              <ListItemIcon sx={{ ...tab.listItemIconStyle }}>
                <tab.icon sx={{ ...tab.iconStyle }} />
              </ListItemIcon>
            )}
            <ListItemText primary={t(tab.title)} />
            {!!tab?.secondaryAction && (
              <Badge
                sx={{ mr: 1.5 }}
                badgeContent={tab?.secondaryAction?.content}
                color={tab?.secondaryAction?.color}
              />
            )}
            {!tab?.noCollapse && (
              <IconButton size="small">
                {open ? (
                  <ExpandLess sx={{ fontSize: "inhert" }} />
                ) : (
                  <ExpandMore sx={{ fontSize: "inhert" }} />
                )}
              </IconButton>
            )}
          </ListItemButton>
          {tab?.noCollapse ? (
            <DrawerList tabs={tab?.children} tab_sx={{ pl: 6 }} />
          ) : (
            <Collapse
              in={open || openSidebarDialog}
              timeout="auto"
              unmountOnExit
            >
              <DrawerList tabs={tab?.children} tab_sx={{ pl: 5 }} />
            </Collapse>
          )}
        </Fragment>
      ) : (
        <ListItem
          disablePadding
          id={tab?.id}
          component={Link}
          to={tab?.href}

          sx={{ color: "text.title"
            //  , pl:2 
            }}
          secondaryAction={
            !!tab?.secondaryAction && (
              <Badge
                badgeContent={tab?.secondaryAction?.content}
                color={tab?.secondaryAction?.color}
              />
            )
          }
        >
          <ListItemButton
            onClick={() => {
              drawerContext?.close && drawerContext?.close();
            }}
            selected={selected}
            sx={{ ...tab_sx }}
          >
            {!!tab?.icon && (
              <ListItemIcon sx={{ ...tab.listItemIconStyle }}>
                <tab.icon sx={{ ...tab.iconStyle }} />
              </ListItemIcon>
            )}
            <ListItemText
              primary={
                isMapitShipOnly && tab?.title === "Orders"
                  ? t("Store Orders")
                  : t(tab?.title)
              }
            />
          </ListItemButton>
        </ListItem>
      )}
    </>
  );
}
